import {
	SET_MODULES,
	SET_MODULE,
	CLEAR_MODULES,
	CLEAR_MODULE,
	ADD_MODULE,
	UPDATE_MODULE,
	REMOVE_MODULE,
} from './actionTypes';

export const module = (state = {}, action) => {
	switch (action.type) {
		case SET_MODULE:
			return action.payload;
		case UPDATE_MODULE:
			if (state._id.toString() !== action.payload._id.toString()) {
				return state;
			}

			// Otherwise, this is the one we want - return an updated value
			return {
				...state,
				...action.payload,
			};
		case CLEAR_MODULE:
			return {};
		default:
			return state;
	}
};

export default (state = [], action) => {
	switch (action.type) {
		case SET_MODULES:
			return action.payload;
		case ADD_MODULE:
			return [...state, action.payload];
		case UPDATE_MODULE:
			return state.map((item) => {
				if (item._id !== action.payload._id) {
					return item;
				}

				// Otherwise, this is the one we want - return an updated value
				return {
					...item,
					...action.payload,
				};
			});
		case REMOVE_MODULE:
			return state.map((item) => {
				if (item._id !== action.payload._id) {
					return item;
				}

				// Otherwise, this is the one we want - return an updated value
				return {
					...item,
				};
			});
		case CLEAR_MODULES:
			return [];
		default:
			return state;
	}
};
